// Local purchase photos are kept as data URLs. A quota/privacy-mode failure
// must reach the transaction's error handler instead of showing false success.
export function writeLocalPurchaseJson(key, value, storage) {
  try {
    const target = storage ?? window.localStorage
    const serialized = JSON.stringify(value)
    target.setItem(key, serialized)
    if (target.getItem(key) !== serialized) throw new Error('Local write verification failed')
  } catch {
    // Never expose serialized purchases, photos or browser exception details.
    throw new Error('This local test could not be saved in this browser. Your captures are still open. Check available browser storage and retry before closing this transaction.')
  }
}
